module.exports = __webpack_public_path__ + "static/media/icon_video_play_transparent.823d305a.svg";